<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
</div>
<div class="modal-title d-flex flex-row">
    <h2>{{dialogTitle}}</h2>
</div>

<mat-dialog-content>
    <mat-horizontal-stepper #stepper>
        <mat-step>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="d-flex flex-row justify-content-end">
                        <p class="created-date">{{reservationDetails.createDate}}</p>
                    </div>
                    <div class="d-flex flex-row label justify-content-between align-items-end">
                        <div>
                            {{ 'RESERVATIONS.NAME' | translate }}
                        </div>
                        <div class="d-flex flex-row align-items-end">
                         <!-- <mat-icon class="profile">person</mat-icon> -->
                         <div class="end-item">{{ reservationDetails.subscriber?.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="d-flex flex-row label justify-content-between align-items-end">
                        <div>
                            {{ 'RESERVATIONS.GUESTS' | translate }}
                        </div>
                        <div class="d-flex flex-row align-items-end">
                         <mat-icon class="profile">person</mat-icon>
                         <div class="end-item">{{ reservationDetails.numberOfPeoples }}</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-row label justify-content-between align-items-end">
                        <div>
                            {{ 'RESERVATIONS.COMMENT' | translate }}
                        </div>
                        <div class="d-flex flex-row align-items-end">
                         <!-- <div class="end-item">{{ venueMaxCapacity }}</div> -->
                        </div>
                    </div>
                    <div class="d-flex flex-row">
                        <p *ngIf="reservationDetails.note == ''">{{ 'RESERVATIONS.NO_SPECIALITIES' | translate }}</p>
                        <p *ngIf="reservationDetails.note != ''">{{reservationDetails.note}}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-row label justify-content-between align-items-end">
                        <div>
                            {{ 'RESERVATIONS.CONTACT' | translate }}
                        </div>
                        <div class="d-flex flex-row align-items-end">
                         <!-- <div class="end-item">{{ reservationDetails.subscriber?.pnone }} | {{reservationDetails.subscriber?.email}} </div> -->
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row">
                            <i><mat-icon class="profile">email</mat-icon></i>
                            <div class="ms-1">{{ reservationDetails.subscriber?.email }}</div>
                        </div>
                        <div class="d-flex flex-row">
                            <i><mat-icon class="profile">local_phone</mat-icon></i>
                            <div class="ms-1">{{ reservationDetails.subscriber?.pnone }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <container-element class="w-100" [ngSwitch]="dialogTitle.toString().toLowerCase()">
                    <div *ngSwitchCase="'pending reservation'">
                        <div *ngIf="loading" class="row info">
                            <mat-spinner class="api-data-spinner"></mat-spinner>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-full"(click)="approve()">{{ 'CONFIRM' | translate }}</button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-gradient-border"(click)="refuse()">{{ 'DECLINE' | translate }}</button>
                            </div>
                        </div>
                    </div>
                    
                    <div *ngSwitchCase="'confirmed reservation'">
                      <!-- rescind button -->
                    </div>
                    
                    <div *ngSwitchCase="'refused reservation'">
                      
                    </div>
                    
                    <!-- <div *ngSwitchDefault>...</div> -->
                  </container-element>
            </div>
        </mat-step> 
        
    </mat-horizontal-stepper>

</mat-dialog-content>

<!--<mat-dialog-actions>
    <button class="mat-raised-button"(click)="close()">Close</button>
    <button class="mat-raised-button mat-primary"(click)="save()">Save</button>
</mat-dialog-actions> -->